import request from '../../../../shared/request'
import moment from 'moment'

export function getJobList(filters) {
  // mount query string
  let qs = ''

  // filter by name
  if (filters && filters.name) qs += `?name=${filters.name}`

  return request(`/reports/general/purchase-orders-report/job-list${qs}`)
}

export function getOrganizationList(filters) {
  return request(`/reports/general/purchase-orders-report/organization-list/`)
}

export function getFullReport(filters) {
  // mount query string
  let qs = ''
  // add date range
  if (filters.date_range) {
    qs += `?startDate=${moment(filters.date_range[0]).format('YYYY-MM-DD')}&endDate=${moment(
      filters.date_range[1]
    ).format('YYYY-MM-DD')}`
  }

  // add job
  if (filters.job_id) qs += `&job_id=${filters.job_id}`

  // add company id
  if (filters.organization_id) qs += `&organization_id=${filters.organization_id}`

  return request(`/reports/general/purchase-orders-report/full-report/${qs}`)
}



// WEBPACK FOOTER //
// ./src/redux/api/reports/general/purchaseOrders.js